import { ReturnFundsAfterClosureType } from '@/modules/plan/plan.types';
import { baseStoreCreator } from '@/utils/store';

export interface AdditionalPayload {
  availableBalance: string;
  maximumElectionAmount: string;
  maximumElectionAmountCustom?: string;
  minimumElectionAmount: string;
  minimumElectionAmountCustom?: string;
  maximumElectionAmountIRS: string;
  proofOfExpense: string;
  proofOfExpensesCardType: string;
  CIPRequired: boolean;
  CIPAccountClosureDelayDays: string;
  returnFundsAfterCipAccountClosureType: string;
  pendContributionsForCIP: boolean;
  CMSReportingRequired: string;
  allowInvestments: string;
  catchUpElections: string;
  catchUpAge: string;
  investmentOptionsType: string[];
  investmentThreshold: string;
  minimumInvestmentAmount: string;
  aiAdjudicationType: string;

  spendLimit: string;
  spendLimitIRSAmount: string;
  spendLimitCustom: string;
  spendPeriod: string;
  perPersonSpendLimit?: string;
  perPersonSpendLimitAmount: string;
  perCategorySpendLimit?: boolean;
  totalPlanLimit?: boolean;
  totalPlanLimitType?: string;
  isOrphaned?: string;
  generateStatements: string;
  ignoreElectionLimit: boolean;
  luGpDesignationAllowed?: boolean;

  includeToBalanceReminder: string;
}

export const DEFAULT_VALUES: AdditionalPayload = {
  availableBalance: '',
  maximumElectionAmount: '',
  maximumElectionAmountCustom: '',
  minimumElectionAmount: '',
  maximumElectionAmountIRS: '',
  minimumElectionAmountCustom: '',
  proofOfExpense: '',
  proofOfExpensesCardType: '',
  CIPRequired: false,
  CIPAccountClosureDelayDays: '',
  returnFundsAfterCipAccountClosureType: ReturnFundsAfterClosureType.EMPLOYEE,
  pendContributionsForCIP: false,
  CMSReportingRequired: '',
  allowInvestments: '',
  catchUpElections: '',
  catchUpAge: '',
  investmentOptionsType: [],
  investmentThreshold: '',
  aiAdjudicationType: '',
  spendLimit: '',
  minimumInvestmentAmount: '',
  spendLimitIRSAmount: '',
  spendLimitCustom: '',
  spendPeriod: '',
  isOrphaned: '',
  generateStatements: '',
  ignoreElectionLimit: false,
  luGpDesignationAllowed: undefined,
  includeToBalanceReminder: '',
  perPersonSpendLimit: undefined,
  perPersonSpendLimitAmount: '',
  perCategorySpendLimit: undefined,
  totalPlanLimit: undefined,
  totalPlanLimitType: undefined,
};

export const useStore = baseStoreCreator<AdditionalPayload>(DEFAULT_VALUES);

export default useStore;
